import compose from 'lodash/flowRight'

import {withActiveEntityId, withBranchProps} from '../../../../../hooks/routes'

import SystemProblems from './OverviewSystemProblems.container'

export default compose(withActiveEntityId, withBranchProps)(SystemProblems)
